import { Injectable } from '@angular/core';
import { RestService } from '@abp/ng.core';
import { Observable } from 'rxjs';
import { Webshops } from '../../../store/models/webshops';

@Injectable({
    providedIn: 'root'
})
export class LoginsService {

    constructor(
        private restService: RestService,
    ) { }

    getLoggedInUser(userName: string, userPassword: string) : Observable<Webshops.ILoggedInUser> {
        return this.restService.request<void, Webshops.ILoggedInUser>({
            method: 'GET',
            url: '/api/app/webshop/user-login?UserName=' + userName + '&UserPassword=' + userPassword
        });
    }

    getUser() : Observable<Webshops.ILoggedInUser> {
        return this.restService.request<void, Webshops.ILoggedInUser>({
            method: 'GET',
            url: '/api/app/webshop/user'
        });
    }
}
